import * as React from 'react';

import { Container } from '../../../Layout/components/Container';
import { IAgencyPageContent } from '../../store/models';

import './index.scss';

interface IProps {
    content: IAgencyPageContent;
}

export const AboutUs: React.FC<IProps> = ({
    content: {
        about_us_image,
        about_us_text
    }
}) => (
        <div className="about">
            <Container>
                <div className="about__content">
                    <div className="about__title">
                        <h1>Who are we?</h1>
                    </div>
                    <div className="about__text">
                        <p>{about_us_text}</p>
                    </div>
                </div>
            </Container>
            <div className="about__image">
                <img src={about_us_image} alt="About Us" />
            </div>
        </div>
    );
